import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTargetArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTargetArrow"><Path d="M14.5 9.5H18.55L22.25 6L19 5L18 1.75L14.5 5.45V9.5ZM14.5 9.5L11.5 12.5M17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.10051 17.25 6.75 14.8995 6.75 12C6.75 9.10051 9.10051 6.75 12 6.75M14 2.7109C13.3552 2.57273 12.6861 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 11.3139 21.4273 10.6448 21.2891 10" stroke="currentColor"/></CentralIconBase>;
});

export default IconTargetArrow;
